import { BubblePulseMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import { color, RGBColor } from 'd3-color'
import Konva from 'konva'

export class BubblePulseCircleV2 extends Konva.Circle implements Shapes.Shape {
  static readonly shapeName = 'bubble-pulse'
  private _metadata: BubblePulseMetadata
  private _animation: Konva.Animation | null = null

  capabilities: Shapes.Capability[] = []

  constructor(metadata: BubblePulseMetadata) {
    super({
      listening: false,
    })
    this._metadata = metadata
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center() {
    return this.position()
  }

  refresh() {
    if (this._animation) {
      this._animation.stop()
    }

    if (this._metadata.show) {
      this.visible(true)
      this.radius(this._metadata.radius)

      this._animation = this.buildAnimation()
      this._animation.start()
    } else {
      this.visible(false)
    }
  }

  private buildAnimation(): Konva.Animation {
    const pulseDuration = this._metadata.duration * 1000
    const pulseStrokeWidth = this._metadata.strokeWidth
    const pulseStrokeOpacity = this._metadata.strokeOpacity
    return new Konva.Animation((frame) => {
      const normalizedTime = (frame!.time % pulseDuration) / pulseDuration // Normalized time [0, 1]

      let strokeWidth
      let strokeOpacity

      // Dividing animation into phases according to the CSS keyframes
      if (normalizedTime < 0.25) {
        strokeWidth = 0
        strokeOpacity = this._interpolateBetweenValues(0, pulseStrokeOpacity, normalizedTime / 0.25)
      } else if (normalizedTime < 0.5) {
        strokeWidth = this._interpolateBetweenValues(
          0,
          pulseStrokeWidth,
          (normalizedTime - 0.25) / 0.25,
        )
        strokeOpacity = this._interpolateBetweenValues(
          pulseStrokeOpacity,
          0,
          (normalizedTime - 0.25) / 0.25,
        )
      } else {
        strokeWidth = this._interpolateBetweenValues(
          pulseStrokeWidth,
          0,
          (normalizedTime - 0.5) / 0.5,
        )
        strokeOpacity = 0
      }

      this.strokeWidth(strokeWidth)
      const stroke = color(this._metadata.strokeColour) as RGBColor
      stroke.opacity = strokeOpacity

      this.stroke(stroke.formatRgb())
    }, this.getLayer())
  }

  private _interpolateBetweenValues(
    startValue: number,
    endValue: number,
    interpolationFactor: number,
  ): number {
    return (1 - interpolationFactor) * startValue + interpolationFactor * endValue
  }
}
